export const UNIVERSAL_NAVIGATION_ERROR = 'not found: No resource found';